// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0f27822c","732":"ec00f2d7"}[chunkId] + ".chunk.js";
};